import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '@admin/shared/services/admin.storage.service';
import { AppConstants } from '@admin/configs/admin.app.constants';

export const AdminAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  if (!storageService.isLoggedIn()) {
    router.navigate([`${AppConstants.adminBasePath}login`]);
    return false;
  }
  return true;
};

export const AdminPublicRoutes: CanActivateFn = () => {
  const router = inject(Router);
  const storageService = inject(StorageService);
  
  if (storageService.isLoggedIn()) {
    router.navigate([`${AppConstants.adminBasePath}/app/dashboard`]);
    return false;
  } 
  return true;
};